<div class="close">
  <button (click)="close()">
    <img
      alt="close"
      width="20"
      height="20"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">如果你无法成功获取验证链接</div>

<div class="content">
  <div class="item">
    <div class="item-title">
      <img
        width="20"
        height="20"
        src="../../../../assets/images/Icon-wangluo.svg"
        alt=""
      />
      <span
        >更换网络 （ 建议
        <img
          width="20"
          height="20"
          src="../../../../assets/images/Icon-duigouxiao.svg"
          alt=""
          style="margin: 0 5px"
        />
        )</span
      >
    </div>
    <div class="text">1. 退出你的账户</div>
    <div class="text">
      2.
      <span style="color: #009688"
        >重新启动登陆电视/设备使用的调制解 调器和路由器</span
      >或更改网络 （您将获得一个新的IP）
    </div>
    <div class="text">3. 重新登录</div>
  </div>
  <div class="item">
    <div class="item-title">
      <img
        width="20"
        height="20"
        src="../../../../assets/images/Icon-shebeiguanli.svg"
        alt=""
      />
      <span>或者更换设备</span>
    </div>
    <div class="text">每台设备24小时内最多可获取4次链接</div>
  </div>
  <div class="item">
    <div class="item-title">
      <img
        width="20"
        height="20"
        src="../../../../assets/images/Icon-shebeipaibi.svg"
        alt=""
      />
      <span>然后再次尝试获取验证链接</span>
    </div>
    <div class="text">
      在Netflix上：<span style="color: #009688">
        点击“我正在旅行”或者 “暂时观看”
      </span>
      >“发送电子邮件”
    </div>
  </div>
  <button
    [disabled]="disabled"
    [ngClass]="{ disabled: disabled }"
    (click)="onOk()"
  >
    我完成了，重试<span *ngIf="disabled">({{ timeout }} S)</span>
  </button>
</div>
